<template>
  <div v-if="result" class="search-product">
    <a :href="result.detailPage">
      <DefImg :result="result.picture" />
    </a>
    <div class="search-product__description">
      <DefLabels :result="result.labels" />
      <a :href="result.detailPage" class="search-product__name">
        {{ result.name }}
      </a>
      <div v-if="result?.price">
        <DefPriceOld v-if="result?.price?.printPriceOld">
          {{ result?.price?.printPriceOld }}
        </DefPriceOld>
        <DefPrice>
          {{ result?.price?.printPrice }}
        </DefPrice>
      </div>
    </div>
  </div>
</template>

<script>
import DefImg from '@components/Def/DefImg/DefImg.vue';
import DefPrice from '@components/Def/DefPrice/DefPrice.vue';
import DefPriceOld from '@components/Def/DefPriceOld/DefPriceOld.vue';
import DefLabels from '@components/Def/DefLabels/DefLabels.vue';

export default {
  name: 'SearchProduct',
  components: { DefLabels, DefPriceOld, DefPrice, DefImg },
  props: ['result'],
};
</script>

<style lang="scss" scoped>
.search-product {
  display: grid;
  grid-template-columns: 56px 1fr;
  background-color: #fff;
  padding: 12px 0;
  grid-column-gap: 16px;

  &__description {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  &__name {
    display: block;
    font-size: 14px;
    font-weight: 500;
    line-height: 105%;
    letter-spacing: 1.12px;
    margin-bottom: 8px;
  }
  :deep(.def-price) {
    font-size: 14px;
  }
  :deep(.def-price-old) {
    font-size: 12px;
    margin-right: 4px;
  }
}
</style>
